import store from "./store/store.js";
import id from "./id/id.js";
import alias from "./alias/alias.js";
import on from "./on/on.js";
import hooks from "./hooks/hooks.js";
import ref from "./ref/ref.js";
import is from "./is/is.js";
import bind from "./bind/bind.js";
import show from "./show/show.js";
import animate from "./animate/animate.js";
import lazy from "./lazy/lazy.js";
export default (function run() {
    store();
    id();
    alias();
    on();
    hooks();
    ref();
    is();
    bind();
    show();
    animate();
    lazy();
});
